import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';

import * as S from './style';

interface IProps {
  /** onTodayClose */
  onTodayClose?: () => void;
  /** onClose */
  onClose?: () => void;
}

const ModalTodayCloseBtn = ({ onTodayClose, onClose }: IProps) => (
  <S.ModalTodayCloseBtn className="modal-today-close-btn">
    <Button className="btn-today" onClick={onTodayClose}>
      오늘 하루 보지않기
    </Button>
    <Button className="btn-close" onClick={onClose}>
      닫기
    </Button>
  </S.ModalTodayCloseBtn>
);

export default ModalTodayCloseBtn;
